import './extend-entities';
import { createRoot } from 'react-dom/client';
import App from '../components/app';

export default () => {

    const container = document.getElementById('root');

    if (container) {
        const root = createRoot(container);

        root.render(<App />);
    }
}
